// removed by extract-text-webpack-plugin
module.exports = {"wallet":"c-Wallet__wallet"};